export function maskNumber(value: string): string {
  return value?.replace(/\D/g, '') || '';
}
